<template>
  <div class="container">
    <HeadingOne class="-margin-md">収入証明書のご提出</HeadingOne>

    <WizardGroup class="_mb-sm-35 _mb-md-50">
      <MainWizard :active-index="2" type="income"></MainWizard>
    </WizardGroup>

    <section>
      <HeadingThree>アップロード前にご確認ください</HeadingThree>
      <p>以下の場合は、再提出が必要となりますのでご注意ください。</p>
      <ListGroup class="-normal _mb-sm-30 _mb-md-50">
        <ListItem class="-normal">
          画像が極端に小さい、切れている、ぼやけている
        </ListItem>
        <ListItem class="-normal">
          本籍地、個人番号（マイナンバー）などが記載されており紙などで隠されていない状態
        </ListItem>
      </ListGroup>

      <div class="row">
        <div
          v-if="!!userData.file_data1"
          class="col-12 col-md-6 _mb-sm-30 _mb-md-50"
        >
          <HeadingThree>ファイル 1</HeadingThree>
          <ConfirmImage
            :file-name="userData.file_name1"
            :file-data="userData.file_data1"
          ></ConfirmImage>
        </div>
        <div
          v-if="!!userData.file_data2"
          class="col-12 col-md-6 _mb-sm-30 _mb-md-50"
        >
          <HeadingThree>ファイル 2</HeadingThree>
          <ConfirmImage
            :file-name="userData.file_name2"
            :file-data="userData.file_data2"
          ></ConfirmImage>
        </div>
        <div
          v-if="!!userData.file_data3"
          class="col-12 col-md-6 _mb-sm-30 _mb-md-50"
        >
          <HeadingThree>ファイル 3</HeadingThree>
          <ConfirmImage
            :file-name="userData.file_name3"
            :file-data="userData.file_data3"
          ></ConfirmImage>
        </div>
        <div
          v-if="!!userData.file_data4"
          class="col-12 col-md-6 _mb-sm-30 _mb-md-50"
        >
          <HeadingThree>ファイル 4</HeadingThree>
          <ConfirmImage
            :file-name="userData.file_name4"
            :file-data="userData.file_data4"
          ></ConfirmImage>
        </div>
        <!-- 5枚目のアップロード欄が削除
        <div
          v-if="!!userData.file_data5"
          class="col-12 col-md-6 _mb-sm-30 _mb-md-50"
        >
          <HeadingThree>ファイル 5</HeadingThree>
          <ConfirmImage
            :file-name="userData.file_name5"
            :file-data="userData.file_data5"
          ></ConfirmImage>
        </div>
        -->
        <div
          v-if="pension === '02' && !!userData.file_data6"
          class="col-12 col-md-6 _mb-sm-30 _mb-md-50"
        >
          <HeadingThree>ファイル 5</HeadingThree>
          <ConfirmImage
            :file-name="userData.file_name6"
            :file-data="userData.file_data6"
          ></ConfirmImage>
        </div>
        <!-- <template v-else>
          <div v-if="!!userData.file_data1" class="col-12 col-md-6 _mb-sm-30 _mb-md-50">
            <HeadingThree>ファイル 1</HeadingThree>
            <ConfirmImage :file-name="userData.file_name1" :file-data="userData.file_data1"></ConfirmImage>
          </div>
          <div v-if="pension === '02' && !!userData.file_data6" class="col-12 col-md-6 _mb-sm-30 _mb-md-50">
            <HeadingThree>ファイル 2</HeadingThree>
            <ConfirmImage :file-name="userData.file_name6" :file-data="userData.file_data6"></ConfirmImage>
          </div>
        </template> -->
      </div>

      <form @submit.prevent="submitIdentifyFile">
        <BtngroupSingle class="_mb-sm-40">
          <BtnMain class="-main" @click.prevent="submitIdentifyFile">
            この内容でアップロードする
          </BtnMain>
        </BtngroupSingle>
      </form>

      <BtngroupSingle class="-margin-lg">
        <BtnBack class="-back -md" @click.prevent="goBack"> 修正する </BtnBack>
      </BtngroupSingle>
    </section>
  </div>
  <!-- container -->
</template>

<script>
import { goToErrorPage, scrollTop } from "@/utils/Other";
import { initCredentials } from "@/utils/Auth";
import {
  getUserDataLambdaInvoke,
  submitIdentifyFileLambdaInvoke,
} from "@/utils/LambdaHelper";
import { INCOME_CERTIFICATE_IMAGE_AT } from "@/constants/constant";

import HeadingOne from "@/components/heading/HeadingOne";
import HeadingThree from "@/components/heading/HeadingThree";
import MainWizard from "@/components/wizard/MainWizard";
import WizardGroup from "@/components/wizard/WizardGroup";
import BtnMain from "@/components/button/BtnMain";
import BtnBack from "@/components/button/BtnBack";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import ConfirmImage from "@/components/upload/ConfirmImage";
import ListGroup from "@/components/list/ListGroup";
import ListItem from "@/components/list/ListItem";

export default {
  name: "IncomeConfirm",

  components: {
    ListItem,
    ListGroup,
    ConfirmImage,
    HeadingThree,
    BtngroupSingle,
    BtnBack,
    BtnMain,
    WizardGroup,
    MainWizard,
    HeadingOne,
  },
  props: {
    topPageId: { type: String, default: "" },
    previousPageId: { type: String, default: "" },
    nextPageId: { type: String, default: "" },
  },
  data() {
    return {
      certificate: this.$route.query.certificate,
      pension: this.$route.query.pension,
      pensionDoc: this.$route.query.pensionDoc,
      isDisabled: false,
      files: true,
      userData: {
        processing_type: "2",
        file_name1: "",
        file_data1: "",
        file_name2: "",
        file_data2: "",
        file_name3: "",
        file_data3: "",
        file_name4: "",
        file_data4: "",
        file_name5: "",
        file_data5: "",
        file_name6: "",
        file_data6: "",
      },
    };
  },
  created() {
    this.checkQueryParam();
  },
  mounted() {
    try {
      getUserDataLambdaInvoke(this.files)
        .then((res) => {
          for (let key in res) {
            if (Object.prototype.hasOwnProperty.call(this.userData, key)) {
              this.userData[key] = res[key];
            }
          }
        })
        .catch((error) => {
          goToErrorPage(error);
        });
    } catch (e) {
      goToErrorPage(e);
    }
  },
  methods: {
    submitIdentifyFile: function () {
      try {
        if (this.isDisabled) {
          return;
        }
        this.isDisabled = true;
        this.errors = {};
        this.checkQueryParam();

        initCredentials()
          .then(() => {
            submitIdentifyFileLambdaInvoke()
              .then((res) => {
                this.errors = res.errors || {};
                if (Object.keys(this.errors).length > 0) {
                  scrollTop();
                  this.isDisabled = false;
                } else {
                  window.$cookies.set(
                    INCOME_CERTIFICATE_IMAGE_AT,
                    new Date().toJSON(),
                    "15min",
                    "/",
                    null,
                    process.env.VUE_APP_COOKIES_SECURE
                  );
                  this.$router.push({ name: this.nextPageId });
                }
              })
              .catch((error) => {
                goToErrorPage(error);
              });
          })
          .catch((error) => {
            goToErrorPage(error);
          });
      } catch (e) {
        goToErrorPage(e);
      }
    },
    goBack: function () {
      try {
        let queryParam = {
          certificate: this.certificate || "00",
          pension: this.pension || "01",
          pensionDoc: this.pensionDoc || "00",
        };
        this.$router.push({ name: this.previousPageId, query: queryParam });
      } catch (e) {
        goToErrorPage(e);
      }
    },
    checkQueryParam() {
      try {
        if (
          window.__PRERENDER_INJECTED &&
          window.__PRERENDER_INJECTED.isPrerendering
        ) {
          // ビルド時の静的ファイル生成時はチェックしない
          return;
        }
        if (
          ["01", "02", "03", "04", "05"].indexOf(
            this.$route.query.certificate
          ) === -1
        ) {
          this.$router.push({ name: this.topPageId });
        }
        if (["01", "02"].indexOf(this.$route.query.pension) === -1) {
          this.$router.push({ name: this.topPageId });
        }
        if (["02"].indexOf(this.$route.query.pension) === 0) {
          if (["01", "02"].indexOf(this.$route.query.pensionDoc) === -1) {
            this.$router.push({ name: this.topPageId });
          }
        }
      } catch (e) {
        goToErrorPage(e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.card-header {
  background-color: transparent;
  border-bottom: 0px;
}
</style>
